export default "/images/ic_user_orange.svg?40e3324f2ddbcdd0f5c953357ab30177";